import { Link } from 'react-router-dom';
import { MapPin, Phone, ExternalLink } from 'lucide-react';
import { OFFICIAL_CONTACTS, PROJECT_CREATOR } from '../constants/contacts';

const Footer = () => {
  return (
    <footer className="bg-dark text-white">
      <div className="container-max section-padding py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo e descrizione */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/t-alento_logo.png" 
                alt="T-Alento" 
                className="h-8 w-auto"
              />
              <h3 className="text-xl font-bold">T-Alento</h3>
            </div>
            <p className="text-text-light/80 text-sm leading-relaxed">
              L'arte della natura - Casal Velino nel Cilento. 
              Un museo diffuso che unisce arte contemporanea, 
              tradizione e innovazione.
            </p>
          </div>

          {/* Link rapidi */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Esplora</h4>
            <nav className="space-y-2">
              <Link to="/eventi" className="block text-text-light/80 hover:text-white transition-colors duration-200">
                Eventi
              </Link>
              <Link to="/opere" className="block text-text-light/80 hover:text-white transition-colors duration-200">
                Opere d'Arte
              </Link>
              <Link to="/sentieri" className="block text-text-light/80 hover:text-white transition-colors duration-200">
                Sentieri del Cilento
              </Link>
              <Link to="/produttori" className="block text-text-light/80 hover:text-white transition-colors duration-200">
                Produttori Locali
              </Link>
            </nav>
          </div>

          {/* Informazioni */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Informazioni</h4>
            <nav className="space-y-2">
              <Link to="/chi-siamo" className="block text-text-light/80 hover:text-white transition-colors duration-200">
                Chi Siamo
              </Link>
              <Link to="/prompt" className="block text-text-light/80 hover:text-white transition-colors duration-200">
                Gestione Prompt
              </Link>
              <a 
                href={OFFICIAL_CONTACTS.website}
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-text-light/80 hover:text-white transition-colors duration-200"
              >
                <span>Sito Ufficiale</span>
                <ExternalLink size={14} />
              </a>
            </nav>
          </div>

          {/* Contatti */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Contatti</h4>
            <div className="space-y-3">
              <div className="text-text-light/80 text-sm font-medium">
                {OFFICIAL_CONTACTS.organization}
              </div>
              <div className="flex items-center space-x-3">
                <MapPin size={16} className="text-primary flex-shrink-0" />
                <span className="text-text-light/80 text-sm">
                  {OFFICIAL_CONTACTS.address}
                </span>
              </div>
              <div className="flex items-center space-x-3">
                <Phone size={16} className="text-primary flex-shrink-0" />
                <a href={`tel:${OFFICIAL_CONTACTS.phone.replace(/\s+/g, '')}`} className="text-text-light/80 hover:text-white transition-colors duration-200 text-sm">
                  {OFFICIAL_CONTACTS.phone}
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <ExternalLink size={16} className="text-primary flex-shrink-0" />
                <a
                  href={OFFICIAL_CONTACTS.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-text-light/80 hover:text-white transition-colors duration-200 text-sm"
                >
                  {OFFICIAL_CONTACTS.websiteLabel}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-text-light/20 mt-8 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-text-light/60 text-sm">
              © 2025 T-Alento. Tutti i diritti riservati.
            </p>
            <p className="text-text-light/60 text-sm">
              Piattaforma web e app mobile realizzate da{' '}
              <a 
                href={PROJECT_CREATOR.website}
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary hover:text-secondary transition-colors duration-200"
              >
                {PROJECT_CREATOR.name} ({PROJECT_CREATOR.websiteLabel})
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
